import {Autocomplete, AutocompletePublicProps, TextInput} from 'core/components/forms';
import {useFormikContext} from 'formik';
import {useGetFailuresQuery} from 'generated/graphql';
import {FC, useEffect, useRef} from 'react';

export const FailureAutocomplete: FC<React.PropsWithChildren<AutocompletePublicProps> & {othersName: string;}> = ({othersName, name, ...props}) => {
    const {data, loading} = useGetFailuresQuery();
    const {values, setFieldValue} = useFormikContext<Record<string, string | undefined>>();
    const optionsRef = useRef(data?.failures || []);

    if (!loading && data?.failures?.length) {
        optionsRef.current = data.failures;
    }

    const options = loading && optionsRef.current.length ? optionsRef.current : (data?.failures || []);

    useEffect(() => {
        if (values[name]) {
            setFieldValue(othersName, '');
        }
    }, [values[name], name, othersName, setFieldValue]);

    useEffect(() => {
        if (values[othersName]) {
            setFieldValue(name, '');
        }
    }, [values[othersName], name, othersName, setFieldValue]);

    return (
        <>
            <Autocomplete
                options={options}
                loading={loading}
                valueKey='description'
                labelKey='description'
                label='Falla'
                gridProps={{xs: 12}}
                name={name}
                {...props}
            />
            <TextInput name={othersName} multiline={true} rows={3} label='Otro' gridProps={{xs: 12}} />
        </>
    );
};
